import { memo } from 'react';

import { Button, Flex, Form, Input, Tooltip } from 'antd';

import { SendOutlined } from '@ant-design/icons';

import { useResendTimer } from '../../hooks/useResendTimer';

function OtpField({ label, name, onInput, resendCode }) {
  const { isAllowed, timeLeft, startTimer } = useResendTimer('otp_resend');

  const handleClick = () => {
    resendCode();
    startTimer();
  };

  return (
    <Flex vertical={false} gap="small" style={{ alignItems: 'last baseline' }}>
      <Form.Item label={label} name={name} colon={false}>
        <Input.OTP size="large" formatter={str => str.toUpperCase()} length={6} onInput={onInput} />
      </Form.Item>
      <Tooltip placement="top" title="Get a new code">
        <Button
          disabled={!isAllowed}
          size="large"
          type="primary"
          icon={timeLeft > 0 ? null : <SendOutlined />}
          iconPosition="end"
          onClick={handleClick}>
          {timeLeft > 0 && <small>Wait {timeLeft}s</small>}
        </Button>
      </Tooltip>
    </Flex>
  );
}

export default memo(OtpField);
